import React, { useState } from "react";
import { EyeIcon, Loader, Loader2, Pencil, Trash2 } from "lucide-react";

function BillingTable({
  data,
  onEdit,
  onDelete,
  onView,
  viewLoading,
  currentPage,
  increasePage,
  decreasePage,
  reportLoading,
}) {
  return (
    <div className="mt-8 w-full">
      {/* Table Card */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
        {/* Table Header */}
        <div className="px-6 py-4 border-b border-slate-200">
          <h2 className="text-lg font-semibold text-slate-800">
            Billing Rules
          </h2>
          <p className="text-sm text-slate-500">
            Manage minimum billing configuration
          </p>
        </div>

        <div className="overflow-x-auto relative">
          {reportLoading && (
            <div className="absolute inset-0  flex justify-center items-center bg-black/50 z-20">
              <Loader2 size={48} className="text-blue-600 animate-spin" />
            </div>
          )}

          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="px-6 py-3 text-left font-semibold">ID</th>
                <th className="px-6 py-3 text-left font-semibold">
                  Master Type
                </th>
                <th className="px-6 py-3 text-left font-semibold">User ID</th>
                <th className="px-6 py-3 text-left font-semibold">
                  Min Amount
                </th>
                <th className="px-6 py-3 text-left font-semibold">Status</th>
                <th className="px-6 py-3 text-left font-semibold">
                  {" "}
                  {viewLoading ? <Loader2 className="animate-spin" /> : "View"}
                </th>
                <th className="px-6 py-3 text-left font-semibold">Edit</th>
                <th className="px-6 py-3 text-left font-semibold">Delete</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-200">
              {data?.data?.map((item) => (
                <tr key={item.id} className="hover:bg-slate-50 transition">
                  <td className="px-6 py-4 font-medium text-slate-700">
                    {item.id}
                  </td>

                  <td className="px-6 py-4">
                    <span className="capitalize">
                      {item.master_type.replace("_", " ")}
                    </span>
                  </td>

                  <td className="px-6 py-4 text-slate-600">
                    {item.user_id ?? "-"}
                  </td>

                  <td className="px-6 py-4 font-medium text-slate-800">
                    ₹ {Number(item.min_bill_amount).toLocaleString()}
                  </td>

                  <td className="px-6 py-4">
                    {item.is_active ? (
                      <span className="px-3 py-1 text-xs rounded-full bg-green-100 text-green-700 font-medium">
                        Active
                      </span>
                    ) : (
                      <span className="px-3 py-1 text-xs rounded-full bg-red-100 text-red-700 font-medium">
                        Inactive
                      </span>
                    )}
                  </td>

                  <td className="px-6 py-4 ">
                    {/* Edit */}
                    <button
                      onClick={() => onView(item)}
                      className="flex items-center gap-1 text-green-600 hover:text-green-700 font-medium"
                    >
                      <div className="flex items-center gap-1">
                        <EyeIcon size={16} />
                        View
                      </div>
                    </button>
                  </td>

                  <td className="px-6 py-4 ">
                    {/* Edit */}
                    <button
                      onClick={() => onEdit(item)}
                      className="flex items-center gap-1 text-blue-600 hover:text-blue-700 font-medium"
                    >
                      <Pencil size={16} />
                      Edit
                    </button>
                  </td>
                  <td className="px-6 py-4 ">
                    {/* Delete */}
                    <button
                      onClick={() => onDelete(item)}
                      className="flex items-center gap-1 text-red-600 hover:text-red-700 font-medium"
                    >
                      <Trash2 size={16} />
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="w-full flex justify-center items-center gap-3 py-4">
          <button
            type="button"
            onClick={decreasePage}
            disabled={currentPage === 1}
            className="bg-blue-600 text-white rounded-lg disabled:opacity-50 px-3 py-2"
          >
            Prev
          </button>
          <div>
            {" "}
            Page {data?.pagination.current_page} of {data?.pagination.last_page}
          </div>
          <button
            onClick={increasePage}
            disabled={data?.pagination?.last_page === currentPage}
            className="bg-blue-600 text-white rounded-lg px-3 py-2 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default BillingTable;
